import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  refreshRow: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  layers: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  layerLabel: {
    display: 'block'
  },
  assessment: {
    marginTop: theme.spacing(1)
  }
}))

export default useStyles
